import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import DownArrow from '../Svg/DownArrow';

import { isPortrait, height } from '../../utils/size';
import { ThemeConsumer } from '../../utils/theming';
import { getImageUrl } from '../../utils/imageLoading';
import { copyFor } from '../../copy/copy';

export const defaultImages = {
    call: getImageUrl('actionChoiceIcons/action.png', 'DEFAULT_IMAGES_URL'),
    checkregistration: getImageUrl(
        'actionChoiceIcons/electionAction.png',
        'DEFAULT_IMAGES_URL'
    ),
    checkrepposition: getImageUrl('actionChoiceIcons/action.png', 'DEFAULT_IMAGES_URL'),
    donation: getImageUrl('actionChoiceIcons/donation.png', 'DEFAULT_IMAGES_URL'),
    electionreminder: getImageUrl(
        'actionChoiceIcons/electionAction.png',
        'DEFAULT_IMAGES_URL'
    ),
    email: getImageUrl('actionChoiceIcons/email.png', 'DEFAULT_IMAGES_URL'),
    findpollingstation: getImageUrl(
        'actionChoiceIcons/electionAction.png',
        'DEFAULT_IMAGES_URL'
    ),
    link: getImageUrl('actionChoiceIcons/action.png', 'DEFAULT_IMAGES_URL'),
    petition: getImageUrl('actionChoiceIcons/petition.png', 'DEFAULT_IMAGES_URL'),
    poll: getImageUrl('actionChoiceIcons/poll.png', 'DEFAULT_IMAGES_URL'),
    quiz: getImageUrl('actionChoiceIcons/quiz.png', 'DEFAULT_IMAGES_URL'),
    recordvideo: getImageUrl('actionChoiceIcons/action.png', 'DEFAULT_IMAGES_URL'),
    speedometer: getImageUrl('actionChoiceIcons/quiz.png', 'DEFAULT_IMAGES_URL'),
    sentimentpoll: getImageUrl('actionChoiceIcons/poll.png', 'DEFAULT_IMAGES_URL'),
    tweet: getImageUrl('actionChoiceIcons/tweet.png', 'DEFAULT_IMAGES_URL'),
    video: getImageUrl('actionChoiceIcons/action.png', 'DEFAULT_IMAGES_URL'),
    volunteer: getImageUrl('actionChoiceIcons/volunteer.png', 'DEFAULT_IMAGES_URL'),
    voteregistration: getImageUrl(
        'actionChoiceIcons/electionAction.png',
        'DEFAULT_IMAGES_URL'
    )
};

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 6px;
    > h2 {
        width: 95%;
        ${props => !props.isPortrait && `margin-right: 15px;`};
    }
    > div {
        height: 100%;
        width: 15%;
        margin-right: 5px;
    }
`;

const CarouselButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    justify-content: flex-end;
    button {
        &:nth-child(1) {
            margin-right: 8px;
        }
    }
`;

const CarouselButton = styled.button`
    border: 1px solid lightgray;
    background-color: white;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    outline: none;
    transform: ${props => (props.left ? `rotate(90deg)` : `rotate(-90deg)`)};
    cursor: pointer;
    svg {
        ${props => props.left && `margin-left: -4px; margin-top: 2px;`};
        ${props => props.right && `margin-left: -4px; margin-top: 2px;`};
    }
`;

export const CarouselButtonGroup = props => (
    <CarouselButtonContainer {...props}>
        <CarouselButton
            left
            onClick={() => {
                if (props.currPosition !== 0) {
                    props.carouselPrev();
                }
            }}
        >
            <DownArrow width={24} height={24} />
        </CarouselButton>
        <CarouselButton
            right
            onClick={() => {
                if (props.currPosition <= props.carouselLength - 1) {
                    props.carouselNext();
                }
            }}
        >
            <DownArrow width={24} height={24} />
        </CarouselButton>
    </CarouselButtonContainer>
);

CarouselButtonGroup.propTypes = {
    currPosition: PropTypes.number.isRequired,
    carouselLength: PropTypes.number.isRequired,
    carouselPrev: PropTypes.func.isRequired,
    carouselNext: PropTypes.func.isRequired
};

const CarouselSlideWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    height: 100px;
    width: ${props => (props.isLast && !isPortrait() ? 110 : 100)}%;
    border-radius: 4px;
    border: solid 1px #e5e3e3;
    box-shadow: 0 2px 4px 0 #e4e4e4;
    margin-bottom: 5px;
    height: ${props => calculateCarouselSlideHeight(props.isPortrait)}px;
    ${props =>
        props.isPortrait &&
        ` flex-direction: column;
          padding: 12px;`};
`;
const CarouselSlideTitle = styled.h2`
    margin: 0 0.5em 0 0;
    font-family: Lato;
    font-size: 16px;
    font-weight: ${props => (props.isPortrait ? 400 : 600)};
    line-height: 1.38;
    max-width: ${props =>
        isPortrait()
            ? 100
            : (props.hasImage || props.hasDefaultImage) && props.showActionLogo
            ? 70
            : 100}%;
    span {
        color: ${({ theme }) => theme.colors.primary};
        cursor: pointer;
    }
    ${props => props.isPortrait && `padding-top: 12px; text-align: center;`};
`;
const CarouselSlideImage = styled.img`
    max-height: ${() => (isPortrait() ? 60 : 40)}px;
    max-width: ${() => (isPortrait() ? 50 : 30)}%;
    margin: ${() => (isPortrait() ? `8px 0 4px` : `0 12px 0 0`)};
`;

const CarouselSlideActionInfoContainer = styled.div`
    width: 70%;
    display: flex;
    align-items: center;
    flex-direction: ${props => (props.isPortrait ? `column` : `row`)};
    ${props => props.isPortrait && `width: 90%;`};
`;
const CarouselSlideButtonContainer = styled.div`
    width: ${props => (props.isPortrait ? 100 : 30)}%;
`;

const CarouselSlideButton = styled.button`
    font-family: Averta;
    width: 100%;
    border: solid 1px #e5e3e3;
    border-radius: 4px;
    background-color: white;
    height: 55px;
    cursor: pointer;
    word-break: break-word;

    span {
        font-weight: 600;
        font-size: ${() => (isPortrait() ? 24 : 18)}px;
    }

    &:active {
        background-color: ${({ theme }) => theme.colors.primary};
        border: ${({ theme }) => `solid 1px ${theme.colors.primary}`};
        color: #fff;
        span {
            color: #fff;
        }
    }

    ${({ theme }) =>
        !isPortrait() &&
        `   cursor: pointer;
            &:hover {
                background-color: ${theme.colors.primary};
                border: solid 1px ${theme.colors.primary};
                color: #fff;
                span {
                    color: #fff;
                }
        }`};
`;

const calculateCarouselSlideHeight = portraitMode => {
    const wrapper = document.getElementById('ActionChoiceWrapper');
    if (!wrapper && portraitMode) {
        return 300;
    } else if (!portraitMode) {
        return 100;
    }
    return height() - wrapper.offsetTop - 60;
};

export const SpinnerContainer = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
    margin: 0 auto;
    justify-content: center;
    align-content: center;
    position: relative;
`;

class CarouselSlide extends React.Component {
    static propTypes = {
        action: PropTypes.object.isRequired,
        beginAction: PropTypes.func.isRequired,
        cardSpecificButtonLabel: PropTypes.string,
        cardSpecificMessage: PropTypes.string,
        handleActionSelect: PropTypes.func.isRequired,
        hasDefaultImage: PropTypes.bool.isRequired,
        hidePartnerLogo: PropTypes.bool.isRequired,
        isPortrait: PropTypes.bool.isRequired,
        label: PropTypes.string,
        maxLength: PropTypes.number,
        index: PropTypes.number,
        numActions: PropTypes.number,
        partner: PropTypes.object,
        setOverlayPartnerVisible: PropTypes.func.isRequired,
        showActionLogo: PropTypes.bool,
        text: PropTypes.string,
        type: PropTypes.string.isRequired
    };

    render() {
        const title =
            this.props.cardSpecificMessage ||
            this.props.text ||
            copyFor('multiactionCard', 'title', this.props.type) ||
            '';
        const maxTitleLength = this.props.showActionLogo
            ? this.props.maxLength || 100
            : this.props.maxLength || 120;
        const shouldTruncate = title.length > maxTitleLength;

        return (
            <ThemeConsumer>
                {theme => (
                    <CarouselSlideWrapper
                        isLast={this.props.index + 1 === this.props.numActions}
                        isPortrait={this.props.isPortrait}
                    >
                        <CarouselSlideActionInfoContainer
                            isPortrait={this.props.isPortrait}
                        >
                            {this.props.showActionLogo &&
                            this.props.action.cardSpecificLogoId ? (
                                <CarouselSlideImage
                                    src={getImageUrl(
                                        this.props.action.cardSpecificLogoId
                                    )}
                                />
                            ) : this.props.showActionLogo ? ( //eslint-disable-line
                                !this.props.hidePartnerLogo &&
                                this.props.hasPartnerImage ? ( //eslint-disable-line
                                    <CarouselSlideImage
                                        alt={this.props.partner.name}
                                        src={this.props.partner.logoUrl}
                                    /> //eslint-disable-line
                                ) : (
                                    <CarouselSlideImage
                                        alt={this.props.type}
                                        src={defaultImages[this.props.action.type]}
                                    />
                                ) //eslint-disable-line
                            ) : null //eslint-disable-line
                            }
                            <CarouselSlideTitle
                                theme={theme}
                                dangerouslySetInnerHTML={{
                                    __html: title
                                        .slice(0, maxTitleLength)
                                        .concat(shouldTruncate ? `...` : ``)
                                }}
                                hasDefaultImage={this.props.hasDefaultImage}
                                showActionLogo={this.props.showActionLogo}
                                hasImage={
                                    this.props.partner && this.props.partner.logoUrl
                                        ? true
                                        : false
                                }
                                isPortrait={this.props.isPortrait}
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.setOverlayPartnerVisible(
                                        true,
                                        e,
                                        false,
                                        true
                                    );
                                }}
                            />
                        </CarouselSlideActionInfoContainer>
                        <CarouselSlideButtonContainer isPortrait={this.props.isPortrait}>
                            <CarouselSlideButton
                                theme={theme}
                                type={this.props.type}
                                onClick={e => {
                                    e.preventDefault();
                                    this.props.beginAction(this.props.action);
                                    this.props.handleActionSelect();
                                }}
                            >
                                <span>
                                    {this.props.cardSpecificButtonLabel ||
                                        this.props.label ||
                                        copyFor(
                                            'multiactionCard',
                                            'button',
                                            this.props.type
                                        )}
                                </span>
                            </CarouselSlideButton>
                        </CarouselSlideButtonContainer>
                    </CarouselSlideWrapper>
                )}
            </ThemeConsumer>
        );
    }
}

export default connect(
    state => {
        return {
            isPortrait: state.widget.isMobileResolution
        };
    },
    {}
)(CarouselSlide);
